jQuery(function($)
{
    var
        { hide } = orion,
        { resetPaginationParameters } = orion,

        // Pseudo-Constants
        requestUriReplacePatternPageCategory = '[pageCategory]',
        requestUriReplacePatternSearch = '[search]',
        requestUriPattern
			= '/js_catalog/'
				+ requestUriReplacePatternPageCategory
				+ '/filterRemovalHtml/' + requestUriReplacePatternSearch,

        // module-global variables
        $body = $('body'),
        $container = $('.js-filter-remove-container'),
        idLastRequest = 0;

    if (0 === $container.length)
    {
        return;
    }

    function getRequestUri(pageCategory, search)
    {
        return requestUriPattern
            .replace(requestUriReplacePatternPageCategory, pageCategory)
            .replace(requestUriReplacePatternSearch, search);
    }

    function makeRequestPromise(pageCategory, search)
    {
        var
            requestUri = getRequestUri(pageCategory, search),
            requestId = idLastRequest + 1,

            request = $.ajax({
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = requestId;
        idLastRequest += 1;

        return request;
    }

    function handleClick(e)
    {
        var
            $remove = $(this).closest('.js-filter-remove-tags'),
            $input = $('input', $remove),
            $form = $('#custom-filter-options form'),
            $q = $('input[name=q]', $form),
            val = $q.val(),
            targetPrefix = $input.val(),
            $targets;

        e.stopPropagation();
        hide($remove);

        console.log(val);
        val = resetPaginationParameters(val);

        if ('' === targetPrefix)
        {
            val = val.replace(/^.*?(--.*)$/, '$1');
        }
        else if ('endPrice_start' === targetPrefix)
        {
            $('input[name=endPrice_start]').val(0);
        }
        else if ('endPrice_end' === targetPrefix)
        {
            $('input[name=endPrice_end]').val(999999);
        }
        else
        {
            targetPrefix = targetPrefix.replace(/"/, '');
            targetPrefix = targetPrefix.replace(' ', '+');
            $targets = $('.filter [id^=\'' + targetPrefix + '\']', $form);
            $targets.prop('checked', false);
        }

        $q.val(val);
        $form.trigger(orion.constants.EventQChanged);
        $form.trigger(orion.constants.EventReset);
    }

    function reload()
    {
        var
            pageCategory = orion.toPageCategory(),
            { search } = document.location,
            request = makeRequestPromise(pageCategory, search);

        function handleDone(markup)
        {
            if (idLastRequest !== request.requestId)
            {
                // stale request => discard
                return;
            }

            console.log('remove markup');

            $container.each(function()
            {
                $(this).find('> *')
                    .remove()
                    .end()
                    .append($('> *', markup));
            });

            if (orion.getShopViewCode() === 'mobile')
            {
                document.querySelector('.js-filter__result-count').textContent =
                    document.querySelector('.js-category__result-counter').textContent;
            }

            document.querySelector('#content').dispatchEvent(new Event(orion.constants.EventFiltersMarkupReplaced));
        }

        orion.startProcessing('#custom-filter-options, .js-filter-remove-container');
        request
            .done(handleDone)
            .fail(function()
            {
                // console.log("…filter removal snippet request failed");
            })
            .always(function()
            {
                orion.stopProcessing('#custom-filter-options, .js-filter-remove-container');
            });
    }

    $(document).on('click', '.js-filter-remove-tags label', handleClick);

    $body.on(orion.constants.EventFiltersChanged, reload);
});
